import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes.tsx";
// import ProtectedRoutes from "./routes/ProtectedRoutes.tsx";

const App: React.FC = () => {
  return (
    <Router>
      <AppRoutes />
      {/* <ProtectedRoutes /> */}
    </Router>
  );
};

export default App;
